// PoC auth gate. Simple shared password stored in localStorage after first
// entry. E2E bypass via ?token= query string. Will be replaced before any
// production-grade access control.

const STORAGE_KEY = 'rentallens.auth.token';

// Default PoC token. Override via VITE_POC_AUTH_TOKEN at build time.
const expectedToken = import.meta.env.VITE_POC_AUTH_TOKEN ?? 'lejedata-poc';

export function isAuthenticated(): boolean {
  if (typeof window === 'undefined') return false;
  const url = new URL(window.location.href);
  const queryToken = url.searchParams.get('token');
  if (queryToken && queryToken === expectedToken) {
    window.localStorage.setItem(STORAGE_KEY, queryToken);
    return true;
  }
  return window.localStorage.getItem(STORAGE_KEY) === expectedToken;
}

export function login(token: string): boolean {
  if (token !== expectedToken) return false;
  window.localStorage.setItem(STORAGE_KEY, token);
  return true;
}

export function logout(): void {
  window.localStorage.removeItem(STORAGE_KEY);
}
